export enum OrganizationRole {
  PROVIDER = 'PROVIDER',
  CLIENT = 'CLIENT',
}
